export const shape = { borderRadius: 0 };
